import React from "react";
import { connect } from "react-redux";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Cpu } from 'lucide-react';

function CpuUsageChart({ cpuData }) {
    const used = Math.round(cpuData.currentLoad || 0);
    const free = Math.round(100 - used);

    const chartData = [
        { name: 'Used', value: used },
        { name: 'Free', value: free }
    ];

    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2">
                <Cpu className="oct_icon" />
                <h3>CPU Usage</h3>
            </div>
            <div className="oct_sys-chart-subtitle-v2">
                {`${cpuData.manufacturer || ''} ${cpuData.brand || ''} ${cpuData.speed || ''} ${cpuData.speed ? 'GHz' : ''}`.trim()}
            </div>

            <div className="oct_sys-chart-pie-wrapper-v2">
                <ResponsiveContainer width="100%" height={140}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={40}
                            outerRadius={60}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            <Cell fill="#10b981" />
                            <Cell fill="#e2e8f0" />
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div className="oct_sys-chart-pie-center-v2">
                    <span className="oct_sys-chart-pie-value-v2">{used}%</span>
                </div>
            </div>

            <div className="oct_sys-chart-legend-v2">
                <div className="legend-item">
                    <div className="color-box emerald"></div>
                    <span>Used</span>
                </div>
                <div className="legend-item">
                    <div className="color-box slate"></div>
                    <span>Free</span>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    const pageData = state.systemPage;
    return {
        cpuData: pageData.cpu
    };
}

export default connect(mapStateToProps)(CpuUsageChart);